import { IconSchool, IconCertificate } from "@tabler/icons-react";
import Card from "./Card";
import styles from "../TalentProfile.module.css";

const EducationCard = ({ talent }) => {
  return (
    <Card icon={IconSchool} title="Education" subtitle="Academic background">
      {talent?.educations?.map((item, index) => (
        <div className={styles.eduItem} key={index}>
          <div className={styles.eduSchoolName}>{item?.schoolName}</div>
          <div className={styles.eduDegreeRow}>
            <span className={styles.eduField}>{item?.fieldOfStudy}</span>
            <span className={styles.eduSep}>|</span>
            <span className={styles.eduDegree}>{item?.degree}</span>
          </div>
        </div>
      ))}
      <div className={styles.eduItem}>
        {talent?.workHistoryExperience
          ?.filter((item) => item?.workCertificate)
          .map((item, index) => (
            <span className={`cursor-pointer ${styles.eduCert}`} key={index}>
              <IconCertificate size={13} />
              <a href={item?.workCertificate} target="_blank" rel="noreferrer">
              {index+1}.  Uploaded work certificate
              </a>
            </span>
          ))}
      </div>
    </Card>
  );
};

export default EducationCard;
